(function () {
  if (window.__ttlCartCroInit) return;
  window.__ttlCartCroInit = true;

  var MONEY_FORMAT = null;
  var actionBusy = false;
  // 48h CRO test: hide upgrade / bump in drawer, keep shipping bar + checkout.
  // Bogos gifts render in the cart, not the native popup.
  var OFFERS_HIDDEN = true;

  function configEl() {
    return document.querySelector("[data-ttl-cart-cro-config]");
  }

  function cfg() {
    var el = configEl();
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function moneyFormat() {
    if (MONEY_FORMAT) return MONEY_FORMAT;
    var body = document.body;
    MONEY_FORMAT = (body && body.getAttribute("data-money-format")) || "{{amount}} €";
    return MONEY_FORMAT;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat());
    }
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function formatRemain(cents) {
    return (Math.max(0, cents) / 100).toFixed(2).replace(".", ",");
  }

  function packQty(title) {
    var t = String(title || "").toLowerCase();
    if (
      t.indexOf("x6") !== -1 ||
      t.indexOf("6 serum") !== -1 ||
      t.indexOf("6 sérum") !== -1 ||
      t.indexOf("6 mois") !== -1 ||
      t.indexOf("6 month") !== -1 ||
      t.indexOf("6 monat") !== -1
    )
      return 6;
    if (
      t.indexOf("x3") !== -1 ||
      t.indexOf("3 serum") !== -1 ||
      t.indexOf("3 sérum") !== -1 ||
      t.indexOf("3 mois") !== -1 ||
      t.indexOf("3 month") !== -1 ||
      t.indexOf("3 monat") !== -1
    )
      return 3;
    return 1;
  }

  function analyze(cart, data) {
    var state = {
      x1: null,
      hasX3: false,
      hasX6: false,
      hasCure: false,
      hasBump: false,
      remaining: 0,
      unlocked: false
    };
    if (!cart || !data) return state;
    var threshold = data.threshold || 7900;
    state.remaining = Math.max(0, threshold - cart.total_price);
    state.unlocked = cart.total_price >= threshold;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var handle = item.handle;
      var qty = packQty(item.variant_title);
      if (handle === data.serumHandle) {
        if (qty === 3) state.hasX3 = true;
        else if (qty === 6) state.hasX6 = true;
        else if (qty === 1) state.x1 = item;
      }
      if (data.cureHandles && data.cureHandles.indexOf(handle) !== -1) state.hasCure = true;
      if (data.bump && handle === data.bump.handle) state.hasBump = true;
    }
    return state;
  }

  function rewriteDurationLabel(text) {
    if (typeof window.ttlRewriteDurationLabel === "function") {
      return window.ttlRewriteDurationLabel(text);
    }
    return String(text == null ? "" : text)
      .replace(/cure\s+de\s+/gi, "Cure ")
      .replace(/\b1\s*mois\b/gi, "1 sérum")
      .replace(/\b(\d+)\s*mois\b/gi, "$1 sérums")
      .replace(/\b1\s*[- ]?month\b/gi, "1 serum")
      .replace(/\b(\d+)\s*[- ]?months?\b/gi, "$1 serums")
      .replace(/\b1\s*Monat\b/g, "1 Serum")
      .replace(/\b(\d+)\s*Monate?\b/g, "$1 Seren");
  }

  function rewriteCartDurationLabels() {
    var roots = document.querySelectorAll(
      ".mini-cart__item .item_title, .cart__item .cart__item--title, .cart__item .meta"
    );
    for (var i = 0; i < roots.length; i++) {
      var walker = document.createTreeWalker(roots[i], NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (var n = 0; n < nodes.length; n++) {
        var next = rewriteDurationLabel(nodes[n].nodeValue);
        if (next !== nodes[n].nodeValue) nodes[n].nodeValue = next;
      }
    }
  }

  function planMonthsFromItem(item) {
    var alloc = item && item.selling_plan_allocation;
    var plan = alloc && alloc.selling_plan;
    if (!plan) return 0;
    var blob = String(plan.name || "").toLowerCase();
    var opts = plan.options || [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (o && typeof o === "object") blob += " " + (o.value || "") + " " + (o.name || "");
      else blob += " " + o;
    }
    blob = blob.replace(/,/g, ".");
    var m = blob.match(/(\d+(?:\.\d+)?)\s*mois/);
    if (m) return parseFloat(m[1]) || 0;
    m = blob.match(/every\s+(\d+(?:\.\d+)?)\s*months?/);
    if (m) return parseFloat(m[1]) || 0;
    m = blob.match(/(\d+(?:\.\d+)?)\s*-?\s*months?\b/);
    if (m) return parseFloat(m[1]) || 0;
    m = blob.match(/(\d+)\s*-?\s*days?\b/);
    if (m) return Math.round((parseInt(m[1], 10) / 30) * 10) / 10;
    return 0;
  }

  function serumPackLabel(data, count, months) {
    var serum =
      count === 1
        ? data.strings.serumMetaOne || "1 sérum"
        : (data.strings.serumMeta || "__COUNT__ sérums").replace(/__COUNT__/g, String(count));
    if (!months) return serum;
    var monthLabel =
      Math.abs(months % 1) < 0.05 ? String(Math.round(months)) : String(months).replace(".", ",");
    if (Math.abs(months - 1) < 0.05) {
      return (data.strings.serumMetaSubOne || "__PACK__ tous les mois").replace(/__PACK__/g, serum);
    }
    return (data.strings.serumMetaSub || "__PACK__ tous les __MONTHS__ mois")
      .replace(/__PACK__/g, serum)
      .replace(/__MONTHS__/g, monthLabel);
  }

  function decorateSerumLines(cart, data) {
    rewriteCartDurationLabels();
    var items = (cart && cart.items) || [];
    var packHandles = {};
    packHandles[data.serumHandle] = true;
    if (data.cureHandles) {
      for (var h = 0; h < data.cureHandles.length; h++) packHandles[data.cureHandles[h]] = true;
    }
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!packHandles[item.handle]) continue;
      var count = packQty(item.variant_title);
      var months = planMonthsFromItem(item);
      var packText = serumPackLabel(data, count, months);
      var nodes = document.querySelectorAll(
        '.mini-cart__item[data-variant-id="' + item.id + '"] .item_title, .cart__item[data-variant-id="' + item.id + '"] .cart__item--title'
      );
      for (var n = 0; n < nodes.length; n++) {
        var titleEl = nodes[n];
        var existingPack = titleEl.querySelector(".ttl-cart-item-pack");
        if (existingPack) {
          existingPack.textContent = packText;
          continue;
        }
        var meta = document.createElement("div");
        meta.className = "ttl-cart-item-meta";
        meta.innerHTML =
          '<span class="ttl-cart-item-rating">' +
          (data.strings.rating || "") +
          "</span>" +
          '<span class="ttl-cart-item-pack">' +
          packText +
          "</span>";
        titleEl.appendChild(meta);
      }
    }
  }

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) el.setAttribute("hidden", "");
    else el.removeAttribute("hidden");
  }

  var giftPending = false;
  var giftAddFn = null;

  function isCartPage() {
    var path = window.location.pathname || "";
    return path === "/cart" || path.indexOf("/cart/") === 0;
  }

  function giftMountTarget() {
    if (isCartPage()) {
      return document.querySelector(".cart [data-ttl-cart-gift]") || document.querySelector("[data-ttl-cart-gift]");
    }
    return (
      document.querySelector(".custom_cart_content [data-ttl-cart-gift]") ||
      document.querySelector("[data-ttl-cart-gift]")
    );
  }

  function hideBogosPopup() {
    if (document.getElementById("ttl-bogos-popup-hide")) return;
    var style = document.createElement("style");
    style.id = "ttl-bogos-popup-hide";
    style.textContent =
      "#freegifts-main-popup-container,#freegifts-main-popup-container.sca-modal-fg{display:none!important;visibility:hidden!important;pointer-events:none!important;}";
    (document.head || document.documentElement).appendChild(style);
  }

  function enableNativeBogosPopup() {
    var style = document.getElementById("ttl-bogos-popup-hide");
    if (style && style.parentNode) style.parentNode.removeChild(style);
    var mounts = document.querySelectorAll("#freegifts-main-page-container");
    for (var i = 0; i < mounts.length; i++) {
      mounts[i].removeAttribute("id");
    }
  }

  function giftHasContent(mount) {
    if (!mount) return false;
    if (mount.querySelector(".ttl-cart-gift-list, .bogos-gifts-slider-container, .freegifts-main-container, .bogos-slider-offer, [class*='bogos']")) {
      return true;
    }
    return mount.childElementCount > 0;
  }

  function ensureGiftMount() {
    hideBogosPopup();
    var target = giftMountTarget();
    if (!target) return null;
    var mounts = document.querySelectorAll("#freegifts-main-page-container");
    var mount = mounts[0] || null;
    for (var i = 1; i < mounts.length; i++) {
      if (mounts[i].parentNode) mounts[i].parentNode.removeChild(mounts[i]);
    }
    if (!mount) {
      mount = document.createElement("div");
      mount.id = "freegifts-main-page-container";
    }
    if (mount.parentNode !== target) target.appendChild(mount);
    return mount;
  }

  function setGiftPending(on) {
    giftPending = !!on;
    if (on) ensureGiftMount();
    if (!on) giftAddFn = null;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function giftList(detail) {
    if (!detail) return [];
    if (detail.gifts && detail.gifts.length) return detail.gifts;
    if (detail.giftsOffer && detail.giftsOffer.arrGiftShow && detail.giftsOffer.arrGiftShow.length) {
      return detail.giftsOffer.arrGiftShow;
    }
    return [];
  }

  function renderCustomGifts(detail) {
    var mount = ensureGiftMount();
    if (!mount) return false;
    var gifts = giftList(detail);
    var addFn = detail && detail.addGiftToCartFunc;
    if (!gifts.length || typeof addFn !== "function") return false;
    giftAddFn = addFn;
    var html = '<div class="ttl-cart-gift-list">';
    for (var i = 0; i < gifts.length; i++) {
      var g = gifts[i];
      var variants = g.variants || [];
      var v = variants[0] || {};
      var img = g.thumbnail || v.thumbnail || "";
      var title = g.title || v.title || "";
      html +=
        '<div class="ttl-cart-gift-item">' +
        (img ? '<img class="ttl-cart-gift-item__img" src="' + escapeHtml(img) + '" alt="" width="56" height="56">' : "") +
        '<div class="ttl-cart-gift-item__copy"><p class="ttl-cart-gift-item__title">' +
        escapeHtml(title) +
        "</p></div>" +
        '<button type="button" class="ttl-cart-gift-item__btn" data-ttl-gift-id="' +
        escapeHtml(v.id || "") +
        '" data-ttl-gift-offer="' +
        escapeHtml(g.belongs_to_offer || "") +
        '">Add</button></div>';
    }
    html += "</div>";
    mount.innerHTML = html;
    return true;
  }

  function hideAllOffers() {
    var offers = document.querySelectorAll("[data-ttl-cart-offers]");
    for (var i = 0; i < offers.length; i++) {
      var root = offers[i];
      setHidden(root.querySelector("[data-ttl-cart-upgrade]"), true);
      setHidden(root.querySelector("[data-ttl-cart-bump]"), true);
      setHidden(root.querySelector("[data-ttl-cart-gift]"), true);
      setHidden(root, true);
    }
    giftPending = false;
  }

  function sync(cart) {
    var data = cfg();
    if (!data || !cart) return;
    var state = analyze(cart, data);
    var mount = ensureGiftMount();
    var showGift = giftPending || giftHasContent(mount);
    var offers = document.querySelectorAll("[data-ttl-cart-offers]");
    var showUpgrade =
      !OFFERS_HIDDEN &&
      !showGift &&
      !!(state.x1 && state.x1.quantity === 1 && !state.hasX3 && !state.hasX6 && !state.hasCure && data.x3Available && data.x3VariantId);
    var showBump =
      !OFFERS_HIDDEN &&
      !showGift &&
      !state.unlocked &&
      !state.hasBump &&
      data.bump &&
      data.bump.available &&
      data.bump.variantId &&
      data.bump.price >= state.remaining &&
      state.remaining > 0;

    for (var i = 0; i < offers.length; i++) {
      var root = offers[i];
      var upgrade = root.querySelector("[data-ttl-cart-upgrade]");
      var bump = root.querySelector("[data-ttl-cart-bump]");
      var gift = root.querySelector("[data-ttl-cart-gift]");
      var giftHere = showGift && gift && mount && gift.contains(mount);
      setHidden(upgrade, !showUpgrade);
      setHidden(bump, !showBump);
      setHidden(gift, !giftHere);
      setHidden(root, !(showUpgrade || showBump || giftHere));
      if (showUpgrade) {
        var saveEl = root.querySelector("[data-ttl-upgrade-save]");
        if (saveEl && data.strings.upgradeSave) {
          saveEl.textContent = data.strings.upgradeSave.replace("__AMOUNT__", formatMoney(data.savePrice));
        }
      }
    }
    decorateSerumLines(cart, data);
  }

  function postCart(url, payload) {
    return new Promise(function (resolve, reject) {
      if (window.jQuery) {
        window.jQuery.ajax({
          url: url,
          type: "POST",
          dataType: "json",
          cache: false,
          data: payload,
          success: resolve,
          error: function (xhr) {
            reject(xhr);
          }
        });
        return;
      }
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw body;
          return body;
        });
      }).then(resolve, reject);
    });
  }

  function getCart() {
    return new Promise(function (resolve, reject) {
      if (window.jQuery) {
        window.jQuery.ajax({
          url: "/cart.js",
          dataType: "json",
          cache: false,
          success: resolve,
          error: reject
        });
        return;
      }
      fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
        .then(function (r) {
          return r.json();
        })
        .then(resolve, reject);
    });
  }

  function applyCart(cart) {
    var fn = window.refreshCart;
    if (typeof fn === "function") {
      fn(cart);
    }
    sync(cart);
  }

  function afterChange() {
    return getCart().then(function (cart) {
      if (isCartPage()) {
        window.location.reload();
        return cart;
      }
      applyCart(cart);
      return cart;
    });
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.setAttribute("aria-busy", busy ? "true" : "false");
  }

  function onUpgrade(btn) {
    var data = cfg();
    if (!data || !data.x3VariantId || actionBusy) return;
    actionBusy = true;
    setBusy(btn, true);
    getCart()
      .then(function (cart) {
        var state = analyze(cart, data);
        if (!state.x1 || state.hasX3 || state.hasX6 || state.hasCure) throw new Error("no-x1");
        return postCart("/cart/change.js", { id: state.x1.key, quantity: 0 }).then(function () {
          return postCart("/cart/add.js", { id: data.x3VariantId, quantity: 1 });
        });
      })
      .then(afterChange)
      .catch(function () {
        setBusy(btn, false);
      })
      .then(function () {
        actionBusy = false;
      });
  }

  function onBump(btn) {
    var data = cfg();
    if (!data || !data.bump || !data.bump.variantId || actionBusy) return;
    actionBusy = true;
    setBusy(btn, true);
    postCart("/cart/add.js", { id: data.bump.variantId, quantity: 1 })
      .then(afterChange)
      .catch(function () {
        setBusy(btn, false);
      })
      .then(function () {
        actionBusy = false;
      });
  }

  function keepDrawerOpen() {
    var containers = document.querySelectorAll(".cart_container");
    for (var i = 0; i < containers.length; i++) {
      containers[i].classList.add("active_link");
    }
    document.body.classList.add("blocked-scroll");
  }

  var bogosGuardUntil = 0;
  var bogosSelector =
    '[class*="bogos"], [id*="bogos"], .freegifts-main-container, .bogos-gifts-slider-container, .bogos-slider-offer, .ttl-cart-gift, #freegifts-main-page-container';

  function isBogosEvent(e) {
    var t = e.target;
    if (!t) return false;
    if (t.closest && t.closest(bogosSelector)) return true;
    return false;
  }

  function armBogosGuard() {
    bogosGuardUntil = Date.now() + 1200;
  }

  function bogosGuarded() {
    return Date.now() < bogosGuardUntil;
  }

  function refreshGiftSlot() {
    getCart()
      .then(function (cart) {
        sync(cart);
      })
      .catch(function () {});
  }

  function onShowSlider(e) {
    var detail = (e && e.detail) || {};
    setGiftPending(true);
    ensureGiftMount();
    var mount = document.getElementById("freegifts-main-page-container");
    window.setTimeout(function () {
      if (mount && !giftHasContent(mount)) renderCustomGifts(detail);
      refreshGiftSlot();
    }, 80);
    refreshGiftSlot();
  }

  function onGiftSettled() {
    window.setTimeout(function () {
      var mount = document.getElementById("freegifts-main-page-container");
      if (!giftHasContent(mount)) setGiftPending(false);
      refreshGiftSlot();
    }, 200);
  }

  var BOGOS_POPUP_SEL = "#freegifts-main-popup-container";
  var BOGOS_KEEP_SEL =
    ".bogos-gift-item-add-btn, .btn-add-to-cart, .bogos-slider-close-btn, .sca-close-modal-fg, [data-close], .glider-prev, .glider-next, .glider-dot, .btn-nav-slide, .dropdown, .dropdown-menu, .variant-item";
  var BOGOS_NAV_SEL =
    "a.gift-original-url, .gift-original-url, .bogos-gift-item-image-container, .bogos-gift-item-image, .product-item-thumbnail, .bogos-gift-item-title, .bogos-gift-product-title, a[href*='/products/'], .bogos-offer-gift-item, .product-item";

  function neutralizeBogosProductLinks(root) {
    var targets = [];
    if (root && root.id === "freegifts-main-page-container") {
      targets.push(root);
    } else {
      var doc = root && root.querySelectorAll ? root : document;
      var found = doc.querySelectorAll("#freegifts-main-page-container, .ttl-cart-gift");
      for (var i = 0; i < found.length; i++) targets.push(found[i]);
    }
    for (var t = 0; t < targets.length; t++) {
      var nodes = targets[t].querySelectorAll(
        "a.gift-original-url, a[href*='/products/'], .bogos-offer-gift-item a[href]"
      );
      for (var i = 0; i < nodes.length; i++) {
        var a = nodes[i];
        if (a.closest && a.closest(BOGOS_KEEP_SEL)) continue;
        if (a.getAttribute("data-ttl-bogos-dead") === "1") continue;
        a.setAttribute("data-ttl-bogos-dead", "1");
        a.removeAttribute("href");
        a.removeAttribute("target");
        a.setAttribute("role", "presentation");
        a.setAttribute("tabindex", "-1");
      }
    }
  }

  function onBogosPopupPointer(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var giftUi = t.closest(
      BOGOS_POPUP_SEL +
        ", #freegifts-main-page-container, .ttl-cart-gift, .bogos-gifts-slider-container, .freegifts-main-container"
    );
    if (!giftUi) {
      if (t.closest("[class*='bogos'], [id*='bogos']")) {
        armBogosGuard();
        keepDrawerOpen();
      }
      return;
    }
    armBogosGuard();
    keepDrawerOpen();
    if (t.closest(BOGOS_KEEP_SEL)) return;
    if (!t.closest(BOGOS_NAV_SEL)) return;
    e.preventDefault();
    e.stopPropagation();
  }

  function bindBogos() {
    hideBogosPopup();
    ensureGiftMount();
    document.addEventListener("click", onBogosPopupPointer, true);
    document.addEventListener("auxclick", onBogosPopupPointer, true);
    document.addEventListener(
      "keydown",
      function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        onBogosPopupPointer(e);
      },
      true
    );
    document.addEventListener("fg-gifts:show-slider", onShowSlider);
    document.addEventListener("fg-gifts:updated", onGiftSettled);
    document.addEventListener("fg-gifts:added", function () {
      setGiftPending(false);
      var addedMount = document.getElementById("freegifts-main-page-container");
      if (addedMount && addedMount.querySelector(".ttl-cart-gift-list")) addedMount.innerHTML = "";
      refreshGiftSlot();
    });
    var mount = ensureGiftMount();
    if (mount && !mount._ttlObserved) {
      mount._ttlObserved = true;
      new MutationObserver(function () {
        neutralizeBogosProductLinks(mount);
        if (giftHasContent(mount)) {
          setGiftPending(true);
          refreshGiftSlot();
        }
      }).observe(mount, { childList: true, subtree: true });
    }
    neutralizeBogosProductLinks(mount || document);
    if (
      giftHasContent(mount) ||
      document.querySelector("#freegifts-main-popup-container [class*='bogos'], .bogos-gifts-slider-container")
    ) {
      setGiftPending(true);
      refreshGiftSlot();
    }
  }

  function onPickGift(btn) {
    if (!giftAddFn || !btn) return;
    var variantId = Number(btn.getAttribute("data-ttl-gift-id"));
    var offerId = btn.getAttribute("data-ttl-gift-offer");
    if (!variantId) return;
    setBusy(btn, true);
    Promise.resolve(giftAddFn(variantId, 1, offerId))
      .then(function () {
        setGiftPending(false);
        var mount = document.getElementById("freegifts-main-page-container");
        if (mount) mount.innerHTML = "";
        return afterChange();
      })
      .catch(function () {
        setBusy(btn, false);
      });
  }

  function discountCode() {
    var inputs = document.querySelectorAll(".ttl-cart-promo__input");
    for (var i = 0; i < inputs.length; i++) {
      var value = String(inputs[i].value || "").trim();
      if (value) return value;
    }
    return "";
  }

  function setPromoStatus(root, message, ok) {
    if (!root) return;
    var status = root.querySelector("[data-ttl-promo-status]");
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = "";
      status.classList.remove("is-error", "is-ok");
      return;
    }
    status.hidden = false;
    status.textContent = message;
    status.classList.toggle("is-error", !ok);
    status.classList.toggle("is-ok", !!ok);
  }

  function codeApplied(cart, code) {
    var wanted = String(code || "").toLowerCase();
    if (!wanted || !cart) return false;
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      var entry = codes[i];
      var name = String((entry && entry.code) || entry || "").toLowerCase();
      if (name === wanted && entry.applicable !== false) return true;
    }
    var apps = cart.cart_level_discount_applications || [];
    for (var j = 0; j < apps.length; j++) {
      if (String(apps[j].title || "").toLowerCase() === wanted) return true;
    }
    return false;
  }

  function onApplyPromo(btn) {
    var root = btn && btn.closest(".ttl-cart-promo");
    if (!root) return;
    var input = root.querySelector(".ttl-cart-promo__input");
    var code = input ? String(input.value || "").trim() : "";
    if (!code) {
      setPromoStatus(root, root.getAttribute("data-ttl-promo-empty"), false);
      if (input) input.focus();
      return;
    }
    setBusy(btn, true);
    setPromoStatus(root, "", true);
    var beforeDiscount = 0;
    getCart()
      .then(function (before) {
        beforeDiscount = (before && before.total_discount) || 0;
        return postCart("/cart/update.js", { discount: code });
      })
      .then(function (cart) {
        var increased = ((cart && cart.total_discount) || 0) > beforeDiscount;
        if (!codeApplied(cart, code) && !increased) {
          setBusy(btn, false);
          setPromoStatus(root, root.getAttribute("data-ttl-promo-invalid"), false);
          return;
        }
        var inputs = document.querySelectorAll(".ttl-cart-promo__input");
        for (var i = 0; i < inputs.length; i++) inputs[i].value = code;
        setPromoStatus(root, root.getAttribute("data-ttl-promo-applied"), true);
        return afterChange();
      })
      .catch(function () {
        setBusy(btn, false);
        setPromoStatus(root, root.getAttribute("data-ttl-promo-invalid"), false);
      })
      .then(function () {
        setBusy(btn, false);
      });
  }

  function checkoutUrl() {
    var code = discountCode();
    if (!code) return "/checkout";
    return "/checkout?discount=" + encodeURIComponent(code);
  }

  function bind() {
    document.addEventListener("click", function (e) {
      var upgradeBtn = e.target.closest("[data-ttl-cart-upgrade-btn]");
      if (upgradeBtn) {
        if (OFFERS_HIDDEN) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        onUpgrade(upgradeBtn);
        return;
      }
      var bumpBtn = e.target.closest("[data-ttl-cart-bump-btn]");
      if (bumpBtn) {
        if (OFFERS_HIDDEN) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        onBump(bumpBtn);
        return;
      }
      var giftBtn = e.target.closest("[data-ttl-gift-id]");
      if (giftBtn) {
        e.preventDefault();
        onPickGift(giftBtn);
        return;
      }
      var promoBtn = e.target.closest("[data-ttl-cart-promo-btn]");
      if (promoBtn) {
        e.preventDefault();
        onApplyPromo(promoBtn);
        return;
      }
      var checkout = e.target.closest("[data-ttl-checkout]");
      if (checkout) {
        var url = checkoutUrl();
        if (checkout.tagName === "A") checkout.setAttribute("href", url);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      var input = e.target && e.target.classList && e.target.classList.contains("ttl-cart-promo__input")
        ? e.target
        : null;
      if (!input) return;
      e.preventDefault();
      var btn = input.closest(".ttl-cart-promo").querySelector("[data-ttl-cart-promo-btn]");
      if (btn) onApplyPromo(btn);
    });

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
      var code = discountCode();
      if (!code) return;
      e.preventDefault();
      window.location.href = checkoutUrl();
    });
  }

  function syncStickyPad() {
    if (!isCartPage()) return;
    var sticky = document.querySelector(".ttl-cart-sticky");
    var wrap = document.querySelector(".cart__wrapper");
    if (!sticky || !wrap) return;
    if (window.matchMedia("(max-width: 798px)").matches) {
      wrap.style.paddingBottom = sticky.offsetHeight + 16 + "px";
    } else {
      wrap.style.paddingBottom = "";
    }
  }

  function bindStickyPad() {
    if (!isCartPage()) return;
    syncStickyPad();
    window.addEventListener("resize", syncStickyPad);
    var sticky = document.querySelector(".ttl-cart-sticky");
    if (sticky) sticky.addEventListener("toggle", syncStickyPad, true);
    if (typeof ResizeObserver === "function" && sticky) {
      new ResizeObserver(syncStickyPad).observe(sticky);
    }
  }

  window.ttlCartCro = {
    sync: sync,
    checkoutUrl: checkoutUrl,
    bogosGuarded: bogosGuarded,
    keepDrawerOpen: keepDrawerOpen
  };

  bind();
  bindBogos();
  bindStickyPad();
})();
